module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pay-in__billing-details mt-3"
  }, [_c('div', {
    staticClass: "font-weight-600 mb-3"
  }, [_vm._v("Billing details")]), _vm._v(" "), (_vm.readOnly) ? _c('div', {
    staticClass: "pay-in__billing-display"
  }, [_c('div', [_c('label', [_vm._v("Billing name")]), _vm._v(" "), _c('div', {
    staticClass: "pay-in__billing-value"
  }, [_vm._v(_vm._s(_vm.billingDetails.businessName || '-'))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("VAT Number")]), _vm._v(" "), _c('div', {
    staticClass: "pay-in__billing-value"
  }, [_vm._v(_vm._s(_vm.billingDetails.vat || '-'))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('div', {
    staticClass: "pay-in__billing-value"
  }, [_vm._v(_vm._s(_vm.billingDetails.address || '-'))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("City")]), _vm._v(" "), _c('div', {
    staticClass: "pay-in__billing-value"
  }, [_vm._v(_vm._s(_vm.billingDetails.city || '-'))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Postal Code")]), _vm._v(" "), _c('div', {
    staticClass: "pay-in__billing-value"
  }, [_vm._v(_vm._s(_vm.billingDetails.postalCode || '-'))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "pay-in__billing-value"
  }, [_vm._v(_vm._s(_vm.getCountryName(_vm.billingDetails.country) || '-'))])])]) : _c('div', {
    staticClass: "pay-in__billing-grid"
  }, [_c('div', [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billingDetails.vat),
      expression: "billingDetails.vat"
    }],
    staticClass: "full",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.billingDetails.vat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.billingDetails, "vat", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', [_vm._v("City")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billingDetails.city),
      expression: "billingDetails.city"
    }],
    staticClass: "full",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.billingDetails.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.billingDetails, "city", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Postal Code")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billingDetails.postalCode),
      expression: "billingDetails.postalCode"
    }],
    staticClass: "full",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.billingDetails.postalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.billingDetails, "postalCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_vm._m(1), _vm._v(" "), _c('country-picker', {
    attrs: {
      "placeholder": "Select Country",
      "selectedCountryValue": _vm.billingDetails.selectedCountry,
      "allowEmpty": false,
      "openDirection": "bottom"
    },
    on: {
      "input": _vm.onCountryChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pay-in__billing-grid--span2"
  }, [_c('label', [_vm._v("Billing name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billingDetails.businessName),
      expression: "billingDetails.businessName"
    }],
    staticClass: "full",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.billingDetails.businessName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.billingDetails, "businessName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pay-in__billing-grid--span2"
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billingDetails.address),
      expression: "billingDetails.address"
    }],
    staticClass: "full",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.billingDetails.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.billingDetails, "address", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (!_vm.readOnly) ? _c('div', {
    staticClass: "text-right mt-2"
  }, [_c('button', {
    staticClass: "btn tertiary",
    on: {
      "click": _vm.autoFill
    }
  }, [_vm._v("Auto Fill")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("VAT Number "), _c('span', {
    staticClass: "pay-in__required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Country "), _c('span', {
    staticClass: "pay-in__required"
  }, [_vm._v("*")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-252e6020", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-252e6020"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationPayIn/BillingDetailsForm.vue
// module id = 1970
// module chunks = 0